module.exports = "/**\n * @license\n * Copyright Akveo. All Rights Reserved.\n * Licensed under the MIT License. See License.txt in the project root for license information.\n */\n:host .links {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/components/request-password/request-password.component.scss
// module id = ./src/app/auth/components/request-password/request-password.component.scss
// module chunks = main